// الروابط العامة (Universal Links) التي يفتحها التطبيق: نوجّه المسار داخل الـ SPA
// بدل تركه يبدأ من الجذر فينتهي بصفحة تسجيل الدخول.
import { isNative } from "./capacitor";

export const initDeepLinks = async () => {
  if (!isNative()) return;
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("appUrlOpen", ({ url }) => {
      try {
        const { pathname, search, hash } = new URL(url);
        if (!pathname || pathname === "/") return;
        window.history.pushState({}, "", `${pathname}${search}${hash}`);
        window.dispatchEvent(new PopStateEvent("popstate"));
      } catch {}
    });
  } catch {}
};
